import { GuestCounts } from '@components/shared/selectors/guests-selector/guest-counts.types'

/**
 * The guest counts a search starts with before the user touches anything.
 *
 * Single source of truth — never compare against a literal. Every "has the user
 * picked a guest count?" check compares against this, so bumping the default
 * (1 -> 2 -> 3 ...) only ever requires editing this object.
 */
export const DEFAULT_SEARCH_GUESTS = {
  adults: 2,
  children: 0,
  infants: 0,
  pets: 0,
} satisfies Required<GuestCounts>

/** True while the counts are untouched, i.e. still exactly the defaults. */
export const isDefaultGuestCount = (guests?: GuestCounts): boolean =>
  (guests?.adults ?? DEFAULT_SEARCH_GUESTS.adults) ===
    DEFAULT_SEARCH_GUESTS.adults &&
  (guests?.children ?? DEFAULT_SEARCH_GUESTS.children) ===
    DEFAULT_SEARCH_GUESTS.children &&
  (guests?.infants ?? DEFAULT_SEARCH_GUESTS.infants) ===
    DEFAULT_SEARCH_GUESTS.infants &&
  (guests?.pets ?? DEFAULT_SEARCH_GUESTS.pets) === DEFAULT_SEARCH_GUESTS.pets

/**
 * True when the guest count is a real choice by the user.
 *
 * Pass `hasEditedGuests` from a picker that tracks its own edited state, so
 * deliberately choosing the default value still counts as a choice.
 */
export const hasSelectedGuests = (
  guests?: GuestCounts,
  hasEditedGuests?: boolean
): boolean => !!hasEditedGuests || !isDefaultGuestCount(guests)
